import { FormControl } from '@mui/material';
import { MenuItem } from 'shared/mui/MenuItem/MenuItem';
import { WorkTeam } from 'types/embedded/workTeam';

import { StyledInputLabel, StyledSelect } from './ProviderAccountsWorkTeamSelect.styled';

type ProviderAccountsWorkTeamSelectProps = {
  workTeam?: WorkTeam | null;
};

export const ProviderAccountsWorkTeamSelect: React.FC<ProviderAccountsWorkTeamSelectProps> = ({
  workTeam,
}) => (
  <FormControl fullWidth size="small" variant="outlined">
    <StyledInputLabel id="work-team" shrink size="small">
      Рабочая группа
    </StyledInputLabel>
    <StyledSelect
      disabled
      label="Рабочая группа"
      labelId="work-team"
      size="small"
      value={workTeam?.name || ''}
    >
      <MenuItem value={workTeam?.name || ''}>{workTeam?.name}</MenuItem>
    </StyledSelect>
  </FormControl>
);
